<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
<template>
  <div id="app" v-if="!loading">
    <v-app :style="{
              background: `linear-gradient(to bottom, ${$ajustes.colorSuperior} 10%, ${$ajustes.colorInferior} ${$ajustes.colorDegradado * 25}%, ${$ajustes.colorInferior} 100%)`
            }">
      <div>
        <navBar v-if="$route.path !== '/dashboard'" />
        <router-view :desktop="desktop" @endSplash="endSplash" />
      </div>
    </v-app>
    <footter v-if="$route.path !== '/dashboard'" />
  </div>
</template>
<script>
import navBar from "./components/default/navbar";
import footter from "./components/default/footer";
import axios from 'axios';
export default {
  components: {
    navBar,
    footter,
  },
  name: "App",
  metaInfo: {
 title: "INSEG Ecuador - Formación en Seguridad Global y Transporte",
  titleTemplate: "%s | INSEG",
    htmlAttrs: {
      lang: "es-EC",
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content: "Centro | Formación",
      },
      {
        name: "keywords",
        content: "centro, formacion, seguridad, inseg, seguridad",
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        property: "og:title",
        content: "INSEG | Centro de Formacion Seguridad.",
      },
      { property: "og:site_name", content: "INSEG" },
      { property: "og:type", content: "website" },
      { name: "robots", content: "index,follow" },
    ],
  },
  data() {
    return {
      loading: true,
      popup: true,
      idPc: "",
      imgFondo: "",
      desktop: true,
      splash: true,
      auth: false,
      alertmodel: { active: false, type: "success", message: "" },
    };
  },
  beforeMount: async function () { },
  created() { },
  mounted() {
        this.obtenerAjustes()
  },
  destroyed() { },
  methods: {
    generateIdFromDate() {
      const now = Date.now(); // Ejemplo: 1692203048975
      const id = now.toString(36).slice(-5); // Últimos 5 caracteres
      return id;
    },
    async obtenerAjustes() {
      await axios.get("/obtener_ajustes")
        .then((response) => {
          if (response.data) {            
            this.$ponerAjustes(response.data.data)
          } else {
           this.$ponerAjustesRecomendado()
          }
        })
        .catch(() => {
            this.$ponerAjustesRecomendado()
          });
        this.loading=false
      },
    exchangeLoading(aux) {
      this.loading = aux;
    },
    endSplash() {
      this.splash = false;
    },
    alertactive(type, message) {
      this.alertmodel.type = type;
      this.alertmodel.message = message;
      this.alertmodel.active = true;
      setTimeout(() => {
        this.alertmodel.active = false;
      }, 4000);
    },
    async genVisit() {
      this.$http
        .post("/genvisit")
        .then(() => { })
        .finally();
    },
  },
};
</script>

<style>
.formatCard {
  background-color: rgba(255, 255, 255, 0.527);
  border-radius: 10px;
  padding: 3px;
}

.alert-family {
  line-height: 1.5;
  font-size: 16px !important;
  font-weight: 400;
  color: rgba(0, 255, 255, 0.479);
  padding: 0.7rem 1.5rem !important;
}
</style>
